import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { Utils } from '../../Utils/Utils';
import { StatusMessageHelper } from '../../Utils/StatusMessageHelper';

export interface SetStatusOptions {
    urlPost: string;
}

class RemoveValidityRequest {
    public ConfigIds: HTMLElement[];
    public Password: string;
    public Reason: string;
    public Type: string;
}

export class RemoveValidityPage extends PageBase<SetStatusOptions> {

    private _passwordInput: HTMLInputElement;
    private _reasonInput: HTMLInputElement;

    constructor(options: SetStatusOptions) {
        super(options);
        this.hideRemoveValidity = this.hideRemoveValidity.bind(this);
        this.removeValidityMulti = this.removeValidityMulti.bind(this);
    }

    init(): void {
        const btnCancel = Utils.getJQueryById("btnHideRemoveValidity");
        btnCancel.on("click", this.hideRemoveValidity);
        const btnSubmit = Utils.getJQueryById("btnSubmitRemoveValidity");
        btnSubmit.on("click", this.removeValidityMulti);
        this._passwordInput = document.getElementById("edPasswordRemoveValidity") as HTMLInputElement;
        this._reasonInput = document.getElementById("edRemoveValidityReason") as HTMLInputElement;
    }

    private hideRemoveValidity() {
        $('#removeValiditySettings').attr("hidden", "hidden");
    }

    private removeValidityMulti(e: JQueryEventObject) {
        e.preventDefault();
        let checkAll = $("#selectAll");
        let urlPost = this._options.urlPost;
        let that = this;
        let table = Utils.getJQueryById('tableGameConfigurations').DataTable();
        let statusMessage = Utils.getJQueryById("statusMessageWrapper");
        let ids = $("input[name='selectedConfig']:checked").map(function () {
            return $(this).val();
        });
        let type = $('#edValidityType').val();
        let request = new RemoveValidityRequest();
        request.Password = this._passwordInput.value;
        request.Reason = this._reasonInput.value;
        request.Type = type;
        request.ConfigIds = ids.get();
        $.ajax({
            url: urlPost,
            type: "POST",
            dataType: 'html',
            data: { request: request },
            success: function (data) {
                checkAll.prop('checked', false);
                that.hideRemoveValidity();
                statusMessage.html(data);
                StatusMessageHelper.initValidator();
                StatusMessageHelper.initSatusMessage();
                table.draw();
            }
        });
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/GameConfigurations/RemoveValidityPage.ts
 **/